import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { useGetUser } from '@queries/users/useGetUser';
import { ProfileSettings } from '@components/AppHeader/ProfileSettings';
import { headerTabsOptions } from './headerTabsOptions';
import { AppBar } from '@components/common/AppBar/AppBar';
import { Toolbar } from '@components/common/Toolbar';
import { PageURL } from '@router/pageURL';
import logo from '@images/StrideUp_Logo_RGB_Neg.png';
import { PermissionType } from '@enums/permissionType.enum';
import { IHeaderMenuItem } from './types';
import { useAuth } from '@providers/AuthProvider/AuthContext';
const filterHeaderTabsToRender = (userAccessGroups: PermissionType[]) => {
  return headerTabsOptions.filter(({ permissions }) =>
    permissions?.some((permission: PermissionType) => userAccessGroups.includes(permission)),
  );
};

export const AppHeader = () => {
  const { isSignedIn } = useAuth();
  const { data: user } = useGetUser();

  const userAccessGroups: PermissionType[] = user?.roles.map(r => r.role.type) ?? [];

  const isProfileSettingsDisplayed = isSignedIn;

  const headerTabsToRender = filterHeaderTabsToRender(userAccessGroups);

  return (
    <AppHeaderBody isProfileSettingsDisplayed={isProfileSettingsDisplayed} headerTabsToRender={headerTabsToRender} />
  );
};

type AppHeaderBodyProps = {
  headerTabsToRender: IHeaderMenuItem[];
  isProfileSettingsDisplayed?: boolean;
};

const AppHeaderBody = ({ headerTabsToRender, isProfileSettingsDisplayed }: AppHeaderBodyProps) => {
  return (
    <AppBar>
      <Toolbar className={'h-16'}>
        <Link to={PageURL.ROOT} className={'text-white no-underline'}>
          <img src={logo} alt='Strideup logo' className={'w-16'} />
        </Link>
        <div className={'flex w-full items-center px-1 pl-6'}>
          {headerTabsToRender.map(({ textId, link = '' }) => {
            return (
              <div key={textId} className={'my-0'}>
                <Link to={link} className={'block py-1.5 px-2 text-sm uppercase text-white no-underline'}>
                  <FormattedMessage id={textId} />
                </Link>
              </div>
            );
          })}
        </div>
        {isProfileSettingsDisplayed && <ProfileSettings />}
      </Toolbar>
    </AppBar>
  );
};
